module.exports = __webpack_public_path__ + "img/me.4e1542ab.jpg";